<template>
  <component
    :is="elementComponent"
    :style="style"
    :surface="surface"
    :element="element"
    :content-override="contentOverride"
    :render-scale="renderScale"
    class="absolute"
  />
</template>

<script setup>
  import {storeToRefs} from 'pinia';
  import {
    SurfaceEditorElementImage,
    SurfaceEditorElementText,
    SurfaceEditorElementShape
  } from '#components';

  const props = defineProps({
    element: Object,
    surface: Object,
    contentOverride: {
      type: Object,
      default: null
    },
    renderScale: {
      type: Number,
      default: null
    }
  });

  const surfaceEditorStore = useSurfaceEditorStore();
  const {editedElement, isRotating} = storeToRefs(surfaceEditorStore);

  const elementComponent = computed(() => {
    switch (props.element.type) {
      case SURFACE_EDITOR_ELEMENT_TYPE.image:
        return SurfaceEditorElementImage;
      case SURFACE_EDITOR_ELEMENT_TYPE.text:
        return SurfaceEditorElementText;
      case SURFACE_EDITOR_ELEMENT_TYPE.shape:
        return SurfaceEditorElementShape;

    }
  });

  const style = computed(() => ({
    width: `${props.element.width}px`,
    height: `${props.element.height}px`,
    transform: `translate(${props.element.x}px, ${props.element.y}px) rotate(${props.element.rotation || 0}deg)`,
    transformOrigin: 'center center',
    opacity: props.element.id === editedElement.value?.id
      ? 0
      : props.element.opacity
  }));

</script>
